// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock5-commonHeaderAdmin-bjdoA {
	position: fixed !important;
}

.WhyHostFormBlock5-adminLayout-eisEk {
	padding-top: 64px !important;
}

.WhyHostFormBlock5-box-sfjM6 h2 {
	font-size: 21px;
	font-weight: 600;
}

.WhyHostFormBlock5-exportLink-CX0D8 {
	margin-bottom: -29px;
}

.WhyHostFormBlock5-blockCenter-CEYQF {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.WhyHostFormBlock5-panelHeader-JjGKe {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.WhyHostFormBlock5-currencyselect-w3xfg {
	width: 100%;
	margin-right: 0px;
}

.WhyHostFormBlock5-panelHeader-JjGKe {
	overflow: hidden;
	position: relative;
}

.WhyHostFormBlock5-mar0-JWere {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock5-blockCenter-CEYQF {
		padding: 0px;
	}

	.WhyHostFormBlock5-panelHeader-JjGKe {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.WhyHostFormBlock5-sideAdminPageWrapper-wkrOF {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.WhyHostFormBlock5-panelHeader-JjGKe {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.WhyHostFormBlock5-table-UxkMf {
	display: table;
}

.WhyHostFormBlock5-tableRow-AYrCd {
	display: table-row;
}

.WhyHostFormBlock5-tableCell-Nay8f {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock5-formGroup-hgsGy {
	margin-bottom: 6px;
}

.WhyHostFormBlock5-select-HksSR {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.WhyHostFormBlock5-noMargin-s0n1P {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock5-exportLink-CX0D8 {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock5-labelTextNew-bTkyh {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock5-displayInline-j3KHI {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.WhyHostFormBlock5-btnUPdate-jF9gE {
	display: inline-block;
}

.WhyHostFormBlock5-btnModalDelete-iA3LW {
	display: inline-block;
	margin-left: 15px;
}

.WhyHostFormBlock5-radioBtn-HcCpk {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.WhyHostFormBlock5-backgroundImg-mgBPm {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock5-btnUPdate-jF9gE {
		display: block;
		margin-bottom: 12px;
	}

	.WhyHostFormBlock5-btnModalDelete-iA3LW {
		display: block;
		margin-left: 0px;
	}

	.WhyHostFormBlock5-btnWidth-MioSl {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock5-bannerImageBg-yEOWD {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.WhyHostFormBlock5-bannerDelete-PWnOV {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.WhyHostFormBlock5-modalRoot-GqvQj {
	padding: 32px;
}

.WhyHostFormBlock5-modalBorderBottom-REo6K {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.WhyHostFormBlock5-logInModalBody-RNTX6 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.WhyHostFormBlock5-exportSection-b5mLt {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.WhyHostFormBlock5-exportSectionGridSub-v88VP {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock5-exportText-KVCcd {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.WhyHostFormBlock5-exportLinkImg-mBMaN {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.WhyHostFormBlock5-vtrMiddle-X9oVG {
	vertical-align: middle;
}

.WhyHostFormBlock5-exportImg-poG8v {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock5-profileViewlabel-OMrYZ {
	display: inline-block;
	width: 38%
}

.WhyHostFormBlock5-profileViewMainContent-zeILP {
	display: inline-block;
	width: 62%;
}

.WhyHostFormBlock5-profileViewMain-fs9cl {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.WhyHostFormBlock5-profileViewInner-Ly7IT {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock5-profileImageSection-a3kvw {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.WhyHostFormBlock5-lastviewInner-kRsEh {
	padding: 10px;
}

.WhyHostFormBlock5-whyHostHoriLine-REdnd {
	margin: 30px 0;
}

.WhyHostFormBlock5-tableGrid-stJqA {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.WhyHostFormBlock5-headingContent-_CsUT {
	font-size: 18px;
	font-weight: 500;
}

.WhyHostFormBlock5-refundTextColor-giCsJ {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.WhyHostFormBlock5-dividerLine-E9Qro {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.WhyHostFormBlock5-smallContent-ucXbp {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.WhyHostFormBlock5-sideAdminPageWrapper-wkrOF {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.WhyHostFormBlock5-sideAdminPageWrapper-wkrOF {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.WhyHostFormBlock5-exportSection-b5mLt {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock5-exportSectionGridSub-v88VP {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock5-profileViewlabel-OMrYZ {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock5-profileViewMainContent-zeILP {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.WhyHostFormBlock5-ChangeToUpperCase-dxxTj {
	text-transform: uppercase
}

.WhyHostFormBlock5-noBorder-iAIdI {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.WhyHostFormBlock5-siteAdminHeading-_md3S {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock5-siteAdminSubHeading-hlyf8 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock5-adminFormDivider-tU1zD {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.WhyHostFormBlock5-errorMessage-IzSxz {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.WhyHostFormBlock5-panelHeader-JjGKe {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock5-formGroup-hgsGy {
  margin-bottom: 6px;
}

.WhyHostFormBlock5-select-HksSR {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.WhyHostFormBlock5-labelText-Mk2Tt {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.WhyHostFormBlock5-space1-y1ZIn {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock5-space2-UAAC9 {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock5-space3-Ljwqj {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock5-space4-Oak4H {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock5-space5-nB0Rw {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock5-space6-Rn86a {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock5-space7-IbjPE {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock5-spaceTop8-kK6Lt {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock5-spaceTop1-auhzR {
	margin-top: 6px !important;
}

.WhyHostFormBlock5-spaceTop2-zpLLI {
	margin-top: 12px !important;
}

.WhyHostFormBlock5-spaceTop3-C5Opx {
	margin-top: 18px !important;
}

.WhyHostFormBlock5-spaceTop4-LhcwD {
	margin-top: 24px !important;
}

.WhyHostFormBlock5-spaceTop5-C0epd {
	margin-top: 30px !important;
}

.WhyHostFormBlock5-spaceTop6-RTtiv {
	margin-top: 36px !important;
}

.WhyHostFormBlock5-spaceTop7-dLiaM {
	margin-top: 42px !important;
}

.WhyHostFormBlock5-spaceTop8-kK6Lt {
	margin-top: 48px !important;
}

.WhyHostFormBlock5-noMargin-s0n1P {
	margin: 0px !important;
}

.WhyHostFormBlock5-padding1-E_qJZ {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock5-padding2-AcK4f {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock5-padding3-v7ht1 {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock5-padding4-7Fvrk {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock5-padding5-kEsab {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock5-padding6-KYqcV {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock5-padding7-zRNyK {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock5-paddingTop1-X7FaI {
	padding-top: 6px !important;
}

.WhyHostFormBlock5-paddingTop2-Q7FOM {
	padding-top: 12px !important;
}

.WhyHostFormBlock5-paddingTop3-LM1X9 {
	padding-top: 18px !important;
}

.WhyHostFormBlock5-paddingTop4-wJVz2 {
	padding-top: 24px !important;
}

.WhyHostFormBlock5-paddingTop5-iHdFa {
	padding-top: 30px !important;
}

.WhyHostFormBlock5-paddingTop6-XiyZB {
	padding-top: 36px !important;
}

.WhyHostFormBlock5-paddingTop7-Chsld {
	padding-top: 42px !important;
}

.WhyHostFormBlock5-noPadding-k4zQ7 {
	padding: 0px !important;
}

.WhyHostFormBlock5-textBold-oNQPy {
	font-weight: 500 !important;
}

.WhyHostFormBlock5-textBolder-LHEtq {
	font-weight: 700 !important;
}

.WhyHostFormBlock5-textNormal-UaGXn {
	font-weight: normal !important;
}

.WhyHostFormBlock5-spaceBottom20-E5Hu5 {
	margin-bottom: 20px;
}

.WhyHostFormBlock5-spaceBottom10-yS9DB {
	margin-bottom: 10px;
}

.WhyHostFormBlock5-marginNone-_Iq_a {
	margin: 0;
}

.WhyHostFormBlock5-spaceBottom15-u5DwS {
	margin-bottom: 15px;
}

.WhyHostFormBlock5-marginTopNone-m6Kj1 {
	margin-top: 0;
}

.WhyHostFormBlock5-spaceTop11-A4Cln {
	margin-top: 11px;
}

.WhyHostFormBlock5-spaceTop21-YDjBh {
	margin-top: 21px;
}

.WhyHostFormBlock5-spaceTop20-Vgrj6 {
	margin-top: 20px;
}

.WhyHostFormBlock5-spaceTop10-CrDHt {
	margin-top: 10px;
}

/*New Design Text Colors */

.WhyHostFormBlock5-textDarkBlue-Dx0l7 {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock5-textLightBlue-VFqCH {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock5-textLightSandleGreen-HNpae {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock5-textLightBrown-Wu54S {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock5-textMediumMaroon-Xtxrr {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock5-textBrown-m2J51 {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock5-textMaroon-CdtHH {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock5-textDarkBrown-YTT1s {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock5-textMediumBrown-P4jBE {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock5-textSkyBlue-q5Pc0 {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock5-textGray-G6rga {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `WhyHostFormBlock5-commonHeaderAdmin-bjdoA`,
	"adminLayout": `WhyHostFormBlock5-adminLayout-eisEk`,
	"box": `WhyHostFormBlock5-box-sfjM6`,
	"exportLink": `WhyHostFormBlock5-exportLink-CX0D8`,
	"blockCenter": `WhyHostFormBlock5-blockCenter-CEYQF`,
	"panelHeader": `WhyHostFormBlock5-panelHeader-JjGKe`,
	"currencyselect": `WhyHostFormBlock5-currencyselect-w3xfg`,
	"mar0": `WhyHostFormBlock5-mar0-JWere`,
	"sideAdminPageWrapper": `WhyHostFormBlock5-sideAdminPageWrapper-wkrOF`,
	"table": `WhyHostFormBlock5-table-UxkMf`,
	"tableRow": `WhyHostFormBlock5-tableRow-AYrCd`,
	"tableCell": `WhyHostFormBlock5-tableCell-Nay8f`,
	"formGroup": `WhyHostFormBlock5-formGroup-hgsGy`,
	"select": `WhyHostFormBlock5-select-HksSR`,
	"noMargin": `WhyHostFormBlock5-noMargin-s0n1P`,
	"labelTextNew": `WhyHostFormBlock5-labelTextNew-bTkyh`,
	"displayInline": `WhyHostFormBlock5-displayInline-j3KHI`,
	"btnUPdate": `WhyHostFormBlock5-btnUPdate-jF9gE`,
	"btnModalDelete": `WhyHostFormBlock5-btnModalDelete-iA3LW`,
	"radioBtn": `WhyHostFormBlock5-radioBtn-HcCpk`,
	"backgroundImg": `WhyHostFormBlock5-backgroundImg-mgBPm`,
	"btnWidth": `WhyHostFormBlock5-btnWidth-MioSl`,
	"bannerImageBg": `WhyHostFormBlock5-bannerImageBg-yEOWD`,
	"bannerDelete": `WhyHostFormBlock5-bannerDelete-PWnOV`,
	"modalRoot": `WhyHostFormBlock5-modalRoot-GqvQj`,
	"modalBorderBottom": `WhyHostFormBlock5-modalBorderBottom-REo6K`,
	"logInModalBody": `WhyHostFormBlock5-logInModalBody-RNTX6`,
	"exportSection": `WhyHostFormBlock5-exportSection-b5mLt`,
	"exportSectionGridSub": `WhyHostFormBlock5-exportSectionGridSub-v88VP`,
	"exportText": `WhyHostFormBlock5-exportText-KVCcd`,
	"exportLinkImg": `WhyHostFormBlock5-exportLinkImg-mBMaN`,
	"vtrMiddle": `WhyHostFormBlock5-vtrMiddle-X9oVG`,
	"exportImg": `WhyHostFormBlock5-exportImg-poG8v`,
	"profileViewlabel": `WhyHostFormBlock5-profileViewlabel-OMrYZ`,
	"profileViewMainContent": `WhyHostFormBlock5-profileViewMainContent-zeILP`,
	"profileViewMain": `WhyHostFormBlock5-profileViewMain-fs9cl`,
	"profileViewInner": `WhyHostFormBlock5-profileViewInner-Ly7IT`,
	"profileImageSection": `WhyHostFormBlock5-profileImageSection-a3kvw`,
	"lastviewInner": `WhyHostFormBlock5-lastviewInner-kRsEh`,
	"whyHostHoriLine": `WhyHostFormBlock5-whyHostHoriLine-REdnd`,
	"tableGrid": `WhyHostFormBlock5-tableGrid-stJqA`,
	"headingContent": `WhyHostFormBlock5-headingContent-_CsUT`,
	"refundTextColor": `WhyHostFormBlock5-refundTextColor-giCsJ`,
	"dividerLine": `WhyHostFormBlock5-dividerLine-E9Qro`,
	"smallContent": `WhyHostFormBlock5-smallContent-ucXbp`,
	"ChangeToUpperCase": `WhyHostFormBlock5-ChangeToUpperCase-dxxTj`,
	"noBorder": `WhyHostFormBlock5-noBorder-iAIdI`,
	"siteAdminHeading": `WhyHostFormBlock5-siteAdminHeading-_md3S`,
	"siteAdminSubHeading": `WhyHostFormBlock5-siteAdminSubHeading-hlyf8`,
	"adminFormDivider": `WhyHostFormBlock5-adminFormDivider-tU1zD`,
	"errorMessage": `WhyHostFormBlock5-errorMessage-IzSxz`,
	"labelText": `WhyHostFormBlock5-labelText-Mk2Tt`,
	"space1": `WhyHostFormBlock5-space1-y1ZIn`,
	"space2": `WhyHostFormBlock5-space2-UAAC9`,
	"space3": `WhyHostFormBlock5-space3-Ljwqj`,
	"space4": `WhyHostFormBlock5-space4-Oak4H`,
	"space5": `WhyHostFormBlock5-space5-nB0Rw`,
	"space6": `WhyHostFormBlock5-space6-Rn86a`,
	"space7": `WhyHostFormBlock5-space7-IbjPE`,
	"spaceTop8": `WhyHostFormBlock5-spaceTop8-kK6Lt`,
	"spaceTop1": `WhyHostFormBlock5-spaceTop1-auhzR`,
	"spaceTop2": `WhyHostFormBlock5-spaceTop2-zpLLI`,
	"spaceTop3": `WhyHostFormBlock5-spaceTop3-C5Opx`,
	"spaceTop4": `WhyHostFormBlock5-spaceTop4-LhcwD`,
	"spaceTop5": `WhyHostFormBlock5-spaceTop5-C0epd`,
	"spaceTop6": `WhyHostFormBlock5-spaceTop6-RTtiv`,
	"spaceTop7": `WhyHostFormBlock5-spaceTop7-dLiaM`,
	"padding1": `WhyHostFormBlock5-padding1-E_qJZ`,
	"padding2": `WhyHostFormBlock5-padding2-AcK4f`,
	"padding3": `WhyHostFormBlock5-padding3-v7ht1`,
	"padding4": `WhyHostFormBlock5-padding4-7Fvrk`,
	"padding5": `WhyHostFormBlock5-padding5-kEsab`,
	"padding6": `WhyHostFormBlock5-padding6-KYqcV`,
	"padding7": `WhyHostFormBlock5-padding7-zRNyK`,
	"paddingTop1": `WhyHostFormBlock5-paddingTop1-X7FaI`,
	"paddingTop2": `WhyHostFormBlock5-paddingTop2-Q7FOM`,
	"paddingTop3": `WhyHostFormBlock5-paddingTop3-LM1X9`,
	"paddingTop4": `WhyHostFormBlock5-paddingTop4-wJVz2`,
	"paddingTop5": `WhyHostFormBlock5-paddingTop5-iHdFa`,
	"paddingTop6": `WhyHostFormBlock5-paddingTop6-XiyZB`,
	"paddingTop7": `WhyHostFormBlock5-paddingTop7-Chsld`,
	"noPadding": `WhyHostFormBlock5-noPadding-k4zQ7`,
	"textBold": `WhyHostFormBlock5-textBold-oNQPy`,
	"textBolder": `WhyHostFormBlock5-textBolder-LHEtq`,
	"textNormal": `WhyHostFormBlock5-textNormal-UaGXn`,
	"spaceBottom20": `WhyHostFormBlock5-spaceBottom20-E5Hu5`,
	"spaceBottom10": `WhyHostFormBlock5-spaceBottom10-yS9DB`,
	"marginNone": `WhyHostFormBlock5-marginNone-_Iq_a`,
	"spaceBottom15": `WhyHostFormBlock5-spaceBottom15-u5DwS`,
	"marginTopNone": `WhyHostFormBlock5-marginTopNone-m6Kj1`,
	"spaceTop11": `WhyHostFormBlock5-spaceTop11-A4Cln`,
	"spaceTop21": `WhyHostFormBlock5-spaceTop21-YDjBh`,
	"spaceTop20": `WhyHostFormBlock5-spaceTop20-Vgrj6`,
	"spaceTop10": `WhyHostFormBlock5-spaceTop10-CrDHt`,
	"textDarkBlue": `WhyHostFormBlock5-textDarkBlue-Dx0l7`,
	"textLightBlue": `WhyHostFormBlock5-textLightBlue-VFqCH`,
	"textLightSandleGreen": `WhyHostFormBlock5-textLightSandleGreen-HNpae`,
	"textLightBrown": `WhyHostFormBlock5-textLightBrown-Wu54S`,
	"textMediumMaroon": `WhyHostFormBlock5-textMediumMaroon-Xtxrr`,
	"textBrown": `WhyHostFormBlock5-textBrown-m2J51`,
	"textMaroon": `WhyHostFormBlock5-textMaroon-CdtHH`,
	"textDarkBrown": `WhyHostFormBlock5-textDarkBrown-YTT1s`,
	"textMediumBrown": `WhyHostFormBlock5-textMediumBrown-P4jBE`,
	"textSkyBlue": `WhyHostFormBlock5-textSkyBlue-q5Pc0`,
	"textGray": `WhyHostFormBlock5-textGray-G6rga`
};
module.exports = ___CSS_LOADER_EXPORT___;
